import React, { useState } from "react";
import { Popover, Typography, IconButton, Box, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DescriptionIcon from "@mui/icons-material/Description";
import MDTypography from "components/MDTypography";

const ReportCell = ({ reportText }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [copied, setCopied] = useState(false);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
    setCopied(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(reportText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const open = Boolean(anchorEl);

  if (!reportText || reportText === "-") return "-";

  return (
    <>
      <MDTypography
        variant="caption"
        color="info"
        fontWeight="medium"
        sx={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={handleOpen}
      >
        <DescriptionIcon fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
        View Report
      </MDTypography>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
            sx: {
              p: 2,
              minWidth: 300,
              maxWidth: 400,
              backgroundColor: "#ffffff",
              backgroundImage: "none",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
              borderRadius: "12px",
              fontSize: "0.9rem"
            },
          }}
      >
        <Box display="flex" flexDirection="column">
          <Typography variant="caption" sx={{ mb: 1, whiteSpace: "pre-wrap", fontSize: "1.2rem" }}>
            {reportText}
          </Typography>
          <Box display="flex" justifyContent="flex-end">
            <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
              <IconButton size="small" onClick={handleCopy} color={copied ? "success" : "primary"}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Popover>
    </>
  );
};


export default ReportCell;